import { render, staticRenderFns } from "./applyperson.vue?vue&type=template&id=125b0da6&scoped=true&"
import script from "./applyperson.vue?vue&type=script&lang=js&"
export * from "./applyperson.vue?vue&type=script&lang=js&"
import style0 from "./applyperson.vue?vue&type=style&index=0&id=125b0da6&less=true&scoped=true&lang=css&"
import style1 from "./applyperson.vue?vue&type=style&index=1&less=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "125b0da6",
  null
  
)

export default component.exports